import { useRequestsHandlerData } from '../../../../../hooks/useRequestsHandlerData';

export default function useIsPendingWish() {
  return useRequestsHandlerData([
    {
      address: 'requestsWishSend',
    },
    {
      address: 'requestsUserGetFriend',
    },
  ]);
}
